/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsFAQ_place$ref: FragmentReference;
declare export opaque type AggregatesListingsFAQ_place$fragmentType: AggregatesListingsFAQ_place$ref;
export type AggregatesListingsFAQ_place = {|
  +type: TypeOfPlace,
  +slug: string,
  +parentPlace: ?{|
    +placeForLink: {|
      +slug: string
    |}
  |},
  +stats: ?{|
    +saleOffersCount: number,
    +rentOffersCount: number,
    +saleOffersCount3Month: number,
    +rentOffersCount3Month: number,
    +salePrice: {|
      +percentile10: ?number,
      +median: ?number,
      +percentile90: ?number,
    |},
    +salePricePerM2: {|
      +median: ?number
    |},
    +monthlyRent: {|
      +percentile10: ?number,
      +median: ?number,
      +percentile90: ?number,
    |},
    +yearlyRentPerM2: {|
      +median: ?number
    |},
  |},
  +rating: ?{|
    +cheapest: $ReadOnlyArray<{|
      +label: string,
      +place: {|
        +placeForLink: {|
          +slug: string
        |}
      |},
      +value: number,
    |}>,
    +expensive: $ReadOnlyArray<{|
      +label: string,
      +place: {|
        +placeForLink: {|
          +slug: string
        |}
      |},
      +value: number,
    |}>,
    +popular: ?$ReadOnlyArray<{|
      +label: string,
      +place: {|
        +placeForLink: {|
          +slug: string
        |}
      |},
      +value: number,
    |}>,
  |},
  +$refType: AggregatesListingsFAQ_place$ref,
|};
export type AggregatesListingsFAQ_place$data = AggregatesListingsFAQ_place;
export type AggregatesListingsFAQ_place$key = {
  +$data?: AggregatesListingsFAQ_place$data,
  +$fragmentRefs: AggregatesListingsFAQ_place$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "kind": "Variable",
  "name": "numberOfRooms",
  "variableName": "numberOfRooms"
},
v3 = {
  "kind": "Variable",
  "name": "propertyMainType",
  "variableName": "propertyMainType"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "median",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentile10",
    "storageKey": null
  },
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentile90",
    "storageKey": null
  }
],
v6 = [
  (v4/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Place",
    "kind": "LinkedField",
    "name": "place",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "returnSelfIfIndexIsTrue",
            "value": false
          }
        ],
        "concreteType": "Place",
        "kind": "LinkedField",
        "name": "placeForLink",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "placeForLink(returnSelfIfIndexIsTrue:false)"
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "numberOfRooms"
    },
    {
      "kind": "RootArgument",
      "name": "offerType"
    },
    {
      "kind": "RootArgument",
      "name": "propertyMainType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsFAQ_place",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "municipality"
        }
      ],
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "parentPlace",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "returnSelfIfIndexIsTrue",
              "value": true
            }
          ],
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "placeForLink",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "placeForLink(returnSelfIfIndexIsTrue:true)"
        }
      ],
      "storageKey": "parentPlace(type:\"municipality\")"
    },
    {
      "alias": "stats",
      "args": [
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "concreteType": "ListingsStats",
      "kind": "LinkedField",
      "name": "listingsStatsOptional",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saleOffersCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rentOffersCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saleOffersCount3Month",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rentOffersCount3Month",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ListingsValueStats",
          "kind": "LinkedField",
          "name": "salePrice",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ListingsValueStats",
          "kind": "LinkedField",
          "name": "salePricePerM2",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ListingsValueStats",
          "kind": "LinkedField",
          "name": "monthlyRent",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ListingsValueStats",
          "kind": "LinkedField",
          "name": "yearlyRentPerM2",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "rating",
      "args": [
        (v2/*: any*/),
        {
          "kind": "Variable",
          "name": "offerType",
          "variableName": "offerType"
        },
        (v3/*: any*/)
      ],
      "concreteType": "MunicipalitiesRating",
      "kind": "LinkedField",
      "name": "municipalitiesRating",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MunicipalitiesRatingValues",
          "kind": "LinkedField",
          "name": "cheapest",
          "plural": true,
          "selections": (v7/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MunicipalitiesRatingValues",
          "kind": "LinkedField",
          "name": "expensive",
          "plural": true,
          "selections": (v7/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MunicipalitiesRatingValues",
          "kind": "LinkedField",
          "name": "popular",
          "plural": true,
          "selections": (v7/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Place",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '4a4aff726b3ee255de2cdb6c218a9e9d';

export default node;
